class Header {
  constructor() {
    this.event();
  }
  event() {
    const header = document.querySelector(".l-header");
    window.addEventListener("scroll", () => {
      // モバイル（sp）の場合は150px、PCの場合は50pxスクロールしたら表示
      const isMobile = window.innerWidth < 768;
      const scrollThreshold = isMobile ? 150 : 50;
      header.classList.toggle("is-scrolled", window.scrollY > scrollThreshold);
    });
    // ハンバーガーメニューボタンが存在する場合のみイベントを設定
    $(".hamburger-menu-btn-container").on("click", function () {
      $(this).toggleClass("is-active");
      // .l-headerにもクラスを追加/削除して、SCSSで制御できるようにする
      $(".l-header").toggleClass("is-menu-open");
    });
  }
}